<template>
  <div>
    <v-dialog
      v-model="announceDialog"
      max-width="500"
      transition="dialog-transition"
      content-class="elevation-0 overflow-visible"
    >
      <v-card
        style="
          border-radius: 25px;
          background-image: radial-gradient(circle at 31% 0, #4f48ad, #1d175e);
        "
      >
        <v-card-title class="justify-end p-2">
          <v-btn icon @click="announceDialog = false">
            <v-icon class="text-white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div
          style="
            position: absolute;
            top: 0%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 25px;
          "
        >
          <v-avatar size="100">
            <img src="/all-assets/common/img/announce.png" alt="CPB-IT" />
          </v-avatar>
        </div>
        <div class="container mt-10">
          <div class="text-white">
            <div class="notice_box">
              <v-card
                elevation="0"
                class="mb-3 bg-transparent border border-primary"
                v-for="data in announceData"
                :key="data.id"
              >
                <v-card-text>
                  <div class="text-white" v-html="data.message"></div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["announceData"],

  data() {
    return {
      announceDialog: true
    };
  }
};
</script>

<style scoped>
/* .notice_card:hover {
  box-shadow: 0px 0px 5px 1px rgba(148, 148, 148, 0.3);
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.notice_card:hover .message_color {
  color: #0072bc;
} */

.notice_box {
  max-height: 600px;
  overflow: auto;
}
</style>